import React, { useState, useEffect, DragEvent, ChangeEvent } from "react";
import Header from "../layouts/Header";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
const secretKey = process.env.REACT_APP_SECRET_KEY || "default-fallback-key";

export default function FrontPage() {
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;
  const [activeIndex, setActiveIndex] = useState(0);

  //index
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  // upload file
  const [file, setFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);

  // paste từ bộ nhớ tạm
  useEffect(() => {
    const handlePaste = (e: ClipboardEvent) => {
      if (e.clipboardData) {
        const items = e.clipboardData.items;
        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") !== -1) {
            const blob = items[i].getAsFile();
            if (blob) {
              const pastedFile = new File([blob], `pasted-${Date.now()}.png`, {
                type: blob.type,
              });
              setFile(pastedFile);
              uploadFile(pastedFile);
            }
          }
        }
      }
    };

    window.addEventListener("paste", handlePaste as any);
    return () => window.removeEventListener("paste", handlePaste as any);
  }, []);

  // upload-file
  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      setFile(selectedFile);
      uploadFile(selectedFile);
    }
  };

  //kéo thả
  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const droppedFile = e.dataTransfer.files[0];
      setFile(droppedFile);
      uploadFile(droppedFile);
    }
  };

  // k drag
  const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  // api upload-file
  const uploadFile = async (fileToUpload: File) => {
    setUploading(true);
    const formData = new FormData();
    formData.append("file_upload", fileToUpload);

    try {
      const res = await fetch(`${API_URL}/upload-file`, {
        method: "POST",
        body: formData,
        credentials: "include",
      });
      const data = await res.json();
      // console.log("Upload success:", data);
      if (data.success && data.id) {
        // const encryptedId = CryptoJS.AES.encrypt(
        //   data.id.toString(),
        //   secretKey
        // ).toString();
        
        navigate(`/edit/${encodeURIComponent(data.id)}`); 
      }
    } catch (err) {
      console.error("Upload error:", err);
    } finally {
      setUploading(false);
    }
  };

  // api index server
  useEffect(() => {
    const fetchData = async () => {
      try {

        const res = await fetch(`${API_URL}`, {
          method: 'GET',
          credentials: "include",
        });
        if (!res.ok) {
          throw new Error(`Error ${res.status}`);
        }
        const result = await res.json();
        setData(result);
        // console.log(result)
      } catch (err) {
        console.error("API error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    const timer = setTimeout(fetchData, 0);
    return () => clearTimeout(timer);
  }, [API_URL]);

  // map tab
  const tabs = [
    // {
    //   label: "Chụp ảnh màn hình",
    //   icon: "fa-camera-retro",
    //   content: (
    //     <div className="sec-top__content__url">
    //       <h3>Nhập url</h3>
    //       <div className="group">
    //         <input type="text" className="border rounded-xl py-2 px-6" placeholder="https://demo.com" />
    //         <select className="border rounded-xl p-2 text-center">
    //           <option value="375">375px</option>
    //           <option value="768">768px</option>
    //           <option value="1400">1400px</option>
    //           <option value="1920">1920px</option>
    //         </select>
    //         <button className="btn border rounded-xl p-2 text-center">Chụp</button>
    //       </div>
    //     </div>
    //   ),
    // },
    {
      label: "Tải ảnh lên",
      icon: "fa-desktop",
      content: (
        <div className="sec-top__content__upload" onDrop={handleDrop} onDragOver={handleDragOver} >

          <h3>Chọn file hoặc kéo thả vào đây</h3>

          <input
            type="file"
            id="fileInput"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />

          <button className="btn" onClick={() => document.getElementById("fileInput")?.click()}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="#fff"
            >
              <path d="M440-320v-326L336-542l-56-58 200-200 200 200-56 58-104-104v326h-80ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z" />
            </svg>
            Chọn file
          </button>

          {file && (
            <p style={{ marginTop: "1rem" }}>{`File: ${file.name}`}</p>
          )}

        </div>
      ),
    },
    {
      label: "Dán từ bộ nhớ tạm",
      icon: "fa-regular fa-paste",
      content: (
        <div className="sec-top__content__copy">
          <h3>Sau khi hình ảnh đã được lưu vào bảng tạm, hãy nhấn các phím sau để dán.</h3>
          <div className="list">
            <div className="item">
              <i className="fa-brands fa-windows fa-2x"></i>
              <div className="group">
                <p>Ctrl</p>
                <span>+</span>
                <p>V</p>
              </div>
            </div>
            <div className="item">
              <i className="fa-brands fa-apple fa-2x"></i>
              <div className="group">
                <p>⌘</p>
                <span>+</span>
                <p>V</p>
              </div>
            </div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <Header />

      <main className="main">
        <section className="sec-top">
          <div className="container">
            <div className="content">
              <div className="sec-top__list">
                {tabs.map((tab, index) => (
                  <div
                    key={index}
                    className={`sec-top__item cursor-pointer ${activeIndex === index ? "active" : ""
                      }`}
                    onClick={() => setActiveIndex(index)}
                  >
                    <i className={`fa ${tab.icon} fa-3x`}></i>
                    {tab.label}
                  </div>
                ))}
              </div>

              <div className="sec-top__content">
                {tabs[activeIndex].content}
              </div>
            </div>
          </div>
        </section>
      </main>

    </>
  );
}
